module.exports = __webpack_public_path__ + "static/media/mobImage.272889f0.jpeg";